/**
 * 商品管理
 */
export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: 'zscm.kdg.product.ProductQueryGateway.pageList',
        perm: true
      }
    },
    search: {
      items: [
        {
          type: 'fuzzy-select',
          prop: 'supplierCode',
          label: '供应商',
          api: 'zscm.kdg.KtSupplierGatewayImpl.querySupplierListByChannel',
          apiParams: {
            pageIndex: 1,
            pageSize: 500,
            supplierChannel: 'KDG'
          },
          optionValueProp: 'code',
          optionLabelProp: 'name',
          triggerFocus: true,
          remote: false,
          span: 6
        },
        { type: 'input', prop: 'skuCode', label: '商品编码', span: 6, placeholder: '输入商品编码' },
        { type: 'input', prop: 'productName', label: '商品名称', span: 6, placeholder: '输入商品名称' },
        { type: 'input', prop: 'deviceModel', label: '设备型号', span: 6, placeholder: '输入设备型号' },
        {
          label: '状态',
          type: 'select',
          prop: 'status',
          options: [
            { label: '已上架', value: true },
            { label: '已下架', value: false }
          ],
          span: 6
        }
      ]
    },
    toolbar: {
      noExport: true,
      items: []
    },
    table: {
      columns: [
        { label: '商品编号', prop: 'skuCode', minWidth: 180 },
        { label: '设备类型', prop: 'productType', minWidth: 150 },
        { label: '设备型号', prop: 'deviceModel', minWidth: 150 },
        { label: '商品名称', prop: 'productName', minWidth: 120 },
        { label: '供应商', prop: 'supplierName', minWidth: 150 },
        { label: '品牌厂商', prop: 'factoryName', minWidth: 120 },
        { label: '商品类型', prop: 'cabinetTypeName', minWidth: 120 },
        { label: '商品材质', prop: 'material', minWidth: 120 },
        { label: '成本价（元）', prop: 'costPrice', minWidth: 120 },
        { label: '含税指导价（元）', prop: 'buyPrice', minWidth: 120 },
        { label: '不含税指导价（元）', prop: 'excludeTaxBuyPrice', minWidth: 130 },
        { label: '格口数', prop: 'cellNumTotal', minWidth: 100 }
      ]
    }
  }
}
